import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import withTracker from "./../../withTracker";
import Lightbox from "react-image-lightbox";

class AboutProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: undefined,
      data: undefined,
      showGallery: false,
      photoIndex: 0,
      galleryImgs: [],
    };
  }

  componentDidMount() {
    if (
      this.props &&
      !this.props.data.data.loading &&
      this.props.data.data.content[0]
    ) {
      this.setState({ loading: false, data: this.props.data.data.content[0] });
    }
  }

  componentDidUpdate() {
    if (this.state && this.state.data && this.state.galleryImgs.length < 1) {
      const allUrls = this.state.data.ProjectSections.reduce((all, curr) => {
        const urls =
          curr.Images.length > 0 ? curr.Images.map((e) => e.url) : [];
        return all.length > 0 ? [...all, ...urls] : [...urls];
      });

      this.setState({ galleryImgs: allUrls });
    }
  }

  createMarkup(text) {
    let html = this.state.data.Description || text;
    html = !text
      ? html.split('src="/').join(`src="${window.location.origin}/`)
      : text;
    return { __html: html };
  }

  parseToHtml(text) {
    return <div dangerouslySetInnerHTML={this.createMarkup(text)} />;
  }

  render() {
    return this.state.data ? (
      <div className="about">
        {this.state.showGallery &&
          this.state.galleryImgs[this.state.photoIndex] && (
            <Lightbox
              mainSrc={this.state.galleryImgs[this.state.photoIndex].replace(
                "http://",
                "https://"
              )}
              nextSrc={
                this.state.galleryImgs[
                  (this.state.photoIndex + 1) % this.state.galleryImgs.length
                ] && this.state.galleryImgs.length > 1
                  ? this.state.galleryImgs[
                      (this.state.photoIndex + 1) %
                        this.state.galleryImgs.length
                    ].img
                  : ""
              }
              prevSrc={
                this.state.galleryImgs[
                  (this.state.photoIndex - 1) % this.state.galleryImgs.length
                ] && this.state.galleryImgs.length > 1
                  ? this.state.galleryImgs[
                      (this.state.photoIndex - 1) %
                        this.state.galleryImgs.length
                    ].img
                  : ""
              }
              onMovePrevRequest={() => {
                this.setState({
                  photoIndex:
                    (this.state.photoIndex +
                      this.state.galleryImgs.length -
                      1) %
                    this.state.galleryImgs.length,
                });
              }}
              onMoveNextRequest={() => {
                this.setState({
                  photoIndex:
                    (this.state.photoIndex + 1) % this.state.galleryImgs.length,
                });
              }}
              onCloseRequest={() => this.setState({ showGallery: false })}
              imageCaption={this.state.galleryImgs[this.state.photoIndex].title}
            />
          )}

        <div className="button-top">
          <span>O PROJEKCIE</span>
        </div>
        <main>
          {this.state.data.ProjectSections.map((section, i) => {
            return (
              <React.Fragment key={i}>
                <div
                  className={`text-with-bg text-with-bg--img text-with-bg--img__${i}`}
                  style={{
                    backgroundImage: `url(${
                      section.SectionImage
                        ? section.SectionImage
                        : `/images/img${i % 2 === 0 ? "5" : "2"}.png`
                    })`,
                  }}
                >
                  <span className="text-with-bg__title">{section.Title}</span>
                </div>
                <div className="content-elements">
                  <div className="about-project-info content-element">
                    {this.parseToHtml(section.Description)}
                  </div>
                </div>
                {section.Logotypes && section.Logotypes.length > 0 && (
                  <div className="content-elements--dark-bg">
                    <div className="content-elements content-elements--no-padding">
                      <div className="about-images content-element logotypes">
                        {section.Logotypes.map((logotype) => {
                          return (
                            <div className="logotype">
                              <img src={logotype.url} alt={logotype.title} />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
                {section.Images && section.Images.length > 0 && (
                  <div className="content-elements--dark-bg">
                    <div className="content-elements content-elements--no-padding">
                      <div className="about-images content-element">
                        {section.Images.map((image, i) => {
                          return (
                            <div
                              onClick={() =>
                                this.setState({
                                  photoIndex: i,
                                  showGallery: true,
                                })
                              }
                              key={i}
                              className="captionImage"
                            >
                              <img
                                src={image.url.replace("http://", "https://")}
                                alt="img"
                              />
                              <div className="caption">
                                {this.parseToHtml(image.description)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </main>
      </div>
    ) : (
      ""
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(AboutProject)));



// WEBPACK FOOTER //
// ./src/js/containers/about-project/index.js